module.exports = __webpack_public_path__ + "static/img/zj_achievement_widget_1.c6640b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/zj_achievement_widget_1.png
// module id = 7wQH
// module chunks = 11